import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-panel perks-container support-perks-area box-shadow-transition"
}
const _hoisted_2 = { class: "panel-bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!

  return (_ctx.state.ui.showPerks && _ctx.state.ui.showSupportPerks)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "panel-title" }, " SUPPORT PERKS ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.state.build.SupportPerks), (perk) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "perk-wrapper",
              key: perk
            }, [
              _createVNode(_component_GenericButton, {
                text: _ctx.getPerkButtonName('SupportPerks', perk),
                "class-name": _ctx.getButtonClass('SupportPerks', perk),
                class: "item-hover",
                onMouseover: ($event: any) => (_ctx.showInfo('SupportPerks', perk)),
                onClick: ($event: any) => (_ctx.tagPerk('SupportPerks', perk))
              }, null, 8, ["text", "class-name", "onMouseover", "onClick"])
            ]))
          }), 128)),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "panel-title" }, " MYSTERY BOOSTS ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.state.build.MysteryBoosts), (boost) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "perk-wrapper",
              key: boost
            }, [
              _createVNode(_component_GenericButton, {
                text: _ctx.getPerkButtonName('MysteryBoosts', boost),
                "class-name": _ctx.getButtonClass('MysteryBoosts', boost),
                class: "item-hover",
                onMouseover: ($event: any) => (_ctx.showInfo('MysteryBoosts', boost)),
                onClick: ($event: any) => (_ctx.tagPerk('MysteryBoosts', boost))
              }, null, 8, ["text", "class-name", "onMouseover", "onClick"])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}